module.exports = __webpack_public_path__ + "img/model_47_ug.0b0f9d02.jpg";